<template>
  <v-list-item-content>
    <template v-if="item.groupName">
      <div class="d-flex">
        <v-icon class="mr-4">
          mdi-account-group
        </v-icon>
        <div class="">
          <div class="d-flex align-center">
            <span>{{ item.groupName }}</span>
          </div>
          <div
            class="text-caption grey--text user-details"
            style="max-width: 600px;"
          >
            <span
              v-for="entry of item.users"
              :key="`au_${entry.value}`"
            >
              {{ entry.displayName }}
            </span>
            <v-tooltip
              v-if="item.hiddenUsers.length"
              bottom
            >
              <template #activator="{ on, attrs }">
                <v-chip
                  color="red"
                  outlined
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    left
                    x-small
                  >
                    mdi-eye-off-outline
                  </v-icon>
                  {{ item.hiddenUsers.length }}
                </v-chip>
              </template>
              <div class="text-caption">
                <div class="mb-1">
                  The following users are part of the group but not assignable:
                </div>
                <div
                  v-for="entry of item.hiddenUsers"
                  :key="`uu_${entry.value}`"
                  class="ml-4"
                >
                  {{ entry.displayName }}
                </div>
              </div>
            </v-tooltip>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex">
        <v-icon class="mr-4">
          mdi-account
        </v-icon>
        <div>
          <div class="d-flex align-center">
            <span>{{ item.displayName }}</span>
            <v-icon
              v-if="item.login"
              class="ml-2 grey--text"
              x-small
            >
              mdi-slash-forward
            </v-icon>
            <span
              v-if="item.login"
              class="grey--text"
            >
              {{ item.login }}
            </span>
          </div>
          <div class="text-caption grey--text user-details">
            <span
              v-if="item.isAttorney"
            >
              Attorney
            </span>
            <span>
              {{ item.userType }}
            </span>
            <span
              v-if="item.disabled"
              class="grey--text text--darken-2"
            >
              Inactive
            </span>
          </div>
        </div>
      </div>
    </template>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'UserSelectListItem',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  computed: {
    item () { return this.user || {} },
  },
}
</script>

<style scoped>
.user-details {
  *::after {
    content: "\2022";
    display: inline;
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :last-child::after {
    display: none;
  }
}
</style>
